import React from 'react'

import { Spinner } from '@components/atoms'

import { useNavigate } from 'react-router-dom'
import {
	useAppSelector,
	useAppDispatch,
	masterdataActions,
	customerAuthActions,
	routeActions,
} from '@redux/index'

interface PropsType {
	to?: string
	isShouldLoginPage?: boolean
	children: JSX.Element
}

export const CustomerLoginGuard: React.FC<PropsType> = props => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const currentPath: string = useAppSelector(state => state.route.currentPath)
	const isLogedin: boolean = useAppSelector(state => state.customerAuth.isLogedin)
	const isReduxLoading: boolean = useAppSelector(state => state.customerAuth.isLoading)

	const authWhiteList = ['/customer/info', '/customer/order', '/customer/change-password']
	const authBlackList = ['/customer/login', '/customer/join', '/customer/forgot-password']

	React.useEffect(() => {
		reduxDispatch(masterdataActions.TRIGGER_GET_MAIN_MASTER_DATA(true))
		reduxDispatch(customerAuthActions.IS_LOADING(true))
		reduxDispatch(customerAuthActions.TRIGGER_TOKEN_VALIDATION(true))
	}, [])

	React.useEffect(() => {
		if (!isReduxLoading) {
			if (isLogedin) {
				if (authBlackList.includes(currentPath)) {
					reduxDispatch(routeActions.NAVIGATE_PATH('/'))
				}
			} else if (!isLogedin) {
				if (authWhiteList.includes(currentPath)) {
					reduxDispatch(routeActions.NAVIGATE_PATH('/'))
				}
			}
		}
	}, [currentPath, isLogedin, isReduxLoading])

	return <>{isReduxLoading ? <Spinner /> : props.children}</>
}
